function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionsBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-691"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.19,71.92S91.42,110.52,53.63,170,18.83,306,64.75,362.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S443.6,295.74,434.6,207.52,346.07-9.88,167.19,71.92Z",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.19,71.92S91.42,110.52,53.63,170,18.83,306,64.75,362.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S443.6,295.74,434.6,207.52,346.07-9.88,167.19,71.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-691"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.5,378.48c3-1,8.32-5.89,8.32-5.9s-4.28-2.49-4.57-2.61c-3.37-1.42-10.72-2.18-13.39.93A4.86,4.86,0,0,0,115,378C117.36,379.68,120.9,379.32,123.5,378.48Z",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.91,331.34c.07,0-2.2-4.43-2.38-4.7-2-3-7.74-7.73-11.68-6.61a4.86,4.86,0,0,0-3,6.57c1.07,2.68,4.22,4.34,6.86,5.07C171.81,332.53,178.9,331.35,178.91,331.34Z",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.19,392.39c2.58-1.69,6.14-7.34,6.42-7.79a85.51,85.51,0,0,0,10.06,5.46c2,.94,4.08,1.83,6.16,2.69-1-.26-1.91-.47-2-.49-3.63-.48-10.92.73-12.67,4.43a4.85,4.85,0,0,0,3,6.58c2.72,1,6-.31,8.33-1.81s5.45-6.29,6.26-7.56l2.4,1c3.85,1.53,7.69,3,11.42,4.64,1.31.56,2.58,1.17,3.86,1.76-.9-.22-1.65-.4-1.77-.41-3.63-.48-10.91.73-12.67,4.43a4.84,4.84,0,0,0,3,6.57c2.73,1,6.05-.31,8.33-1.81s5.14-5.82,6.12-7.32c1.28.65,2.57,1.3,3.79,2,.82.49,1.65.9,2.45,1.44l2.38,1.53c1.47,1,3,2.08,4.42,3.12,1,.72,1.92,1.42,2.86,2.12-1.3-.57-3.87-1.65-4.1-1.71-3.51-1-10.9-.93-13.19,2.46a4.84,4.84,0,0,0,1.94,6.95c2.54,1.37,6,.61,8.51-.53,2.73-1.25,7-6.08,7.48-6.69,1.55,1.17,3.05,2.32,4.44,3.43,4.06,3.21,7.44,6.1,10,8.36l2-1.82c-2.68-2.26-6.26-5.2-10.57-8.46-1.57-1.19-3.27-2.44-5-3.7a53.26,53.26,0,0,0,2.44-5.69c3.07.31,8.85-1.28,9.6-1.49.65,1.83,1.26,3.62,1.81,5.31,1.58,4.83,2.79,9,3.68,12.31l2.24-2c-.93-3.09-2.13-6.86-3.62-11.11-.65-1.86-1.38-3.83-2.16-5.85.69-.39,6.25-3.63,8-6.07,1.59-2.22,3-5.49,2.14-8.26a4.86,4.86,0,0,0-6.45-3.23c-3.77,1.61-5.27,8.84-4.94,12.48,0,.22.5,2.53.82,4-.32-.83-.62-1.63-1-2.47-.66-1.68-1.37-3.33-2.12-5.11-.4-.85-.79-1.7-1.2-2.56s-.89-1.73-1.34-2.61c-1.07-2-2.26-4-3.51-6,1.47-.58,6.64-2.72,8.56-4.68s3.8-5,3.36-7.83a4.84,4.84,0,0,0-5.88-4.17c-4,1-6.55,7.94-6.77,11.59,0,.22.12,2.86.22,4.31-.76-1.18-1.51-2.36-2.31-3.53-2.32-3.37-4.78-6.71-7.21-10.05-.75-1-1.48-2.05-2.21-3.08.52-.2,6.72-2.61,8.87-4.8,1.91-2,3.8-5,3.37-7.84a4.85,4.85,0,0,0-5.89-4.17c-4,1-6.55,7.94-6.77,11.59,0,.28.18,4.07.28,5-1.62-2.27-3.21-4.54-4.69-6.84a83.63,83.63,0,0,1-5.42-9.65c.24-.09,6.72-2.58,8.92-4.83,1.91-2,3.8-5,3.37-7.83a4.84,4.84,0,0,0-5.88-4.17c-4,1-6.55,7.94-6.77,11.59,0,.24.13,3.13.23,4.5l-.22.06a61.73,61.73,0,0,1-3.62-10.53c-.51-2-.89-3.91-1.22-5.78,1.25-.34,7-1.95,9.18-3.76s4.32-4.53,4.21-7.42a4.86,4.86,0,0,0-5.4-4.79c-4.05.57-7.38,7.17-8,10.78,0,.19-.16,2.22-.23,3.7-.13-.85-.29-1.72-.4-2.54-.43-3.07-.64-5.9-.81-8.41-.08-1.43-.12-2.73-.15-3.94,1.05-1,5.27-5,6.37-7.53s1.75-6,.32-8.52a4.85,4.85,0,0,0-7-1.77c-3.34,2.38-3.25,9.77-2.14,13.26.1.3,2.13,4.84,2.19,4.79l.06-.06c0,1.16,0,2.41.08,3.78.11,2.52.25,5.37.62,8.46a86.28,86.28,0,0,0,1.66,9.9,62.56,62.56,0,0,0,3.42,10.71l.06.12c-.78-.91-3.05-3.38-3.25-3.55-2.76-2.4-9.51-5.41-13-3.29a4.84,4.84,0,0,0-1.15,7.12c1.74,2.31,5.21,3.08,7.95,3.09,3.08,0,9.16-2.75,9.65-3a85.78,85.78,0,0,0,5.38,10.11c1.16,1.89,2.39,3.77,3.65,5.63-.7-.76-1.33-1.44-1.43-1.53-2.76-2.39-9.51-5.41-13-3.29a4.84,4.84,0,0,0-1.15,7.12c1.73,2.32,5.21,3.08,7.95,3.09s8-2.24,9.38-2.85c.49.71,1,1.43,1.47,2.14,2.36,3.39,4.73,6.78,7,10.16.79,1.2,1.52,2.4,2.25,3.6-.62-.68-1.15-1.24-1.24-1.32-2.76-2.4-9.51-5.41-13-3.29a4.84,4.84,0,0,0-1.14,7.12c1.73,2.31,5.21,3.08,7.94,3.09s7.5-2,9.14-2.74c.72,1.25,1.44,2.5,2.07,3.75.42.86.88,1.66,1.24,2.55s.77,1.74,1.14,2.59c.67,1.68,1.36,3.4,2,5.05.43,1.14.82,2.24,1.21,3.34-.76-1.2-2.32-3.51-2.47-3.69a18.78,18.78,0,0,0-8-5.16,5.46,5.46,0,0,0-.76-.76,4.85,4.85,0,0,0-7.16.86c-2.26,3.42.48,10.28,2.77,13.14.13.17,1.8,1.83,2.87,2.86L199.65,409c-1.47-1-3-2-4.58-3.09l-2.41-1.48c-.8-.51-1.7-.95-2.56-1.43-2-1.08-4.09-2.08-6.21-3,.9-1.29,4-5.92,4.55-8.62s.42-6.24-1.51-8.39a4.85,4.85,0,0,0-7.21-.23c-2.75,3-1.08,10.23.74,13.4.12.2,1.68,2.32,2.57,3.47-1.28-.56-2.56-1.13-3.87-1.66-3.8-1.53-7.69-3-11.56-4.41-1.19-.44-2.37-.9-3.55-1.35.33-.45,4.17-5.88,4.75-8.9.52-2.68.43-6.24-1.51-8.39a4.85,4.85,0,0,0-7.21-.23c-2.75,3-1.08,10.23.75,13.4.13.24,2.39,3.29,3,4-2.6-1-5.18-2-7.69-3.11a83.48,83.48,0,0,1-9.84-5.06c.15-.21,4.19-5.86,4.78-8.95.51-2.68.42-6.24-1.51-8.39a4.85,4.85,0,0,0-7.21-.23c-2.75,3-1.08,10.23.74,13.4.12.21,1.84,2.54,2.69,3.63l-.16.17a62.28,62.28,0,0,1-8.82-6.79c-1.53-1.37-2.91-2.76-4.22-4.15.86-1,4.74-5.47,5.59-8.2s1.1-6.16-.58-8.5a4.86,4.86,0,0,0-7.15-1c-3.06,2.72-2.19,10.06-.73,13.41.08.18,1.1,1.94,1.86,3.21-.58-.63-1.19-1.27-1.74-1.89-2-2.32-3.79-4.57-5.31-6.58-.86-1.15-1.61-2.2-2.31-3.19.35-1.4,1.67-7.05,1.17-9.8s-1.86-6-4.44-7.28a4.84,4.84,0,0,0-6.8,2.38c-1.47,3.82,2.68,9.93,5.52,12.23.25.2,4.45,2.86,4.47,2.79a.64.64,0,0,0,0-.09c.65,1,1.36,2,2.15,3.12,1.48,2,3.18,4.34,5.19,6.71a87.5,87.5,0,0,0,6.85,7.35,63.65,63.65,0,0,0,8.75,7l.12.07c-1.15-.33-4.41-1.14-4.67-1.17-3.63-.48-10.91.73-12.67,4.43a4.85,4.85,0,0,0,3,6.58C133.59,395.17,136.91,393.9,139.19,392.39Z",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,138.71c2.14,3.58,9.85,8.83,9.86,8.83s1.92-6.13,2-6.54c.82-4.67-.34-14.19-5-16.67a6.29,6.29,0,0,0-8.69,3.48C323,131.29,324.46,135.67,326.28,138.71Z",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.89,195.25c0,.09,5-4.06,5.27-4.36,3.27-3.45,7.55-12,5-16.69a6.29,6.29,0,0,0-9.17-1.89c-3.09,2.13-4.28,6.59-4.45,10.13C398.35,186.6,401.89,195.24,401.89,195.25Z",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.19,162.58c2.89,2.77,11.07,5.65,11.72,5.87a111.48,111.48,0,0,0-4,14.31c-.61,2.82-1.14,5.69-1.63,8.57,0-1.35,0-2.56,0-2.73-.44-4.72-4.07-13.6-9.26-14.75a6.29,6.29,0,0,0-7.47,5.65c-.44,3.73,2.14,7.57,4.7,10s9.52,5.09,11.36,5.75c-.18,1.1-.37,2.21-.54,3.31-.83,5.31-1.63,10.61-2.58,15.79-.33,1.82-.73,3.61-1.12,5.4,0-1.2,0-2.21,0-2.36-.44-4.73-4.07-13.6-9.26-14.76a6.29,6.29,0,0,0-7.46,5.66c-.44,3.72,2.13,7.56,4.69,10s8.85,4.82,11,5.62c-.45,1.82-.9,3.64-1.42,5.38-.39,1.18-.67,2.34-1.12,3.51l-1.26,3.45c-.87,2.16-1.76,4.4-2.67,6.5-.62,1.45-1.24,2.83-1.86,4.22.35-1.81,1-5.37,1-5.67.28-4.74-2-14.06-6.92-16a6.29,6.29,0,0,0-8.24,4.46c-1,3.61,1,7.8,3.12,10.61,2.38,3.1,9.71,7.06,10.63,7.55-1,2.29-2.06,4.52-3.06,6.6-2.9,6.07-5.58,11.17-7.7,15.08l2.89,2.06c2.1-4,4.78-9.41,7.66-15.81,1.06-2.33,2.15-4.84,3.24-7.43a66.24,66.24,0,0,0,7.9,1.45c.5,4,4.17,10.84,4.65,11.72-2.13,1.35-4.21,2.64-6.2,3.82-5.65,3.4-10.62,6.14-14.51,8.21l3.15,2.25c3.65-2.06,8.07-4.66,13-7.77,2.17-1.36,4.46-2.86,6.79-4.42.69.76,6.39,6.86,10,8.38,3.27,1.37,7.81,2.22,11.06.33a6.28,6.28,0,0,0,2.23-9.09c-3.12-4.31-12.7-4.12-17.22-2.65-.26.09-3.05,1.35-4.79,2.18.95-.64,1.88-1.26,2.85-1.93,1.93-1.32,3.82-2.69,5.85-4.15l2.9-2.25c1-.74,1.93-1.63,2.91-2.45,2.23-1.94,4.4-4,6.53-6.16,1.16,1.68,5.36,7.61,8.39,9.47s7.39,3.38,10.88,2a6.29,6.29,0,0,0,3.59-8.65c-2.43-4.73-11.94-6-16.62-5.23-.29.05-3.59,1-5.39,1.52,1.27-1.29,2.55-2.58,3.79-3.94,3.6-3.9,7.12-8,10.64-12,1.08-1.24,2.18-2.46,3.26-3.68.41.6,5.24,7.75,8.64,9.84,3,1.85,7.39,3.38,10.89,2a6.29,6.29,0,0,0,3.58-8.65c-2.43-4.73-11.94-6-16.62-5.23-.35.05-5.1,1.4-6.29,1.8,2.4-2.7,4.81-5.37,7.3-7.91a111,111,0,0,1,10.65-9.64c.19.28,5.2,7.77,8.68,9.91,3,1.85,7.39,3.37,10.89,2a6.29,6.29,0,0,0,3.58-8.65c-2.43-4.73-11.94-6-16.62-5.22-.31,0-3.92,1.07-5.63,1.59l-.14-.27a81.39,81.39,0,0,1,12.29-7.61c2.36-1.22,4.68-2.25,7-3.21.79,1.49,4.48,8.26,7.4,10.53s7,4.17,10.6,3.19a6.29,6.29,0,0,0,4.51-8.2c-1.9-5-11.2-7.28-15.94-7-.26,0-2.87.45-4.76.78,1-.41,2.1-.86,3.1-1.24,3.76-1.43,7.28-2.51,10.42-3.44,1.78-.52,3.41-1,4.93-1.34,1.54,1.06,7.79,5.25,11.37,5.9s8.11.49,10.87-2.05a6.29,6.29,0,0,0,.22-9.36c-4-3.53-13.29-1.29-17.38,1.11-.36.21-5.51,4.1-5.43,4.16l.09.06c-1.47.34-3.05.73-4.77,1.18-3.15.87-6.72,1.88-10.52,3.23a113.05,113.05,0,0,0-12.06,5,82.81,82.81,0,0,0-12.57,7.4l-.13.11c.92-1.25,3.4-4.83,3.56-5.13,2.24-4.19,4.11-13.59.42-17.42a6.31,6.31,0,0,0-9.35.6c-2.42,2.87-2.39,7.49-1.61,10.95.88,3.9,6.11,10.81,6.53,11.36a111.52,111.52,0,0,0-11.24,9.72c-2.07,2-4.08,4.12-6.08,6.25.77-1.11,1.44-2.11,1.52-2.26,2.24-4.18,4.11-13.59.42-17.41a6.28,6.28,0,0,0-9.34.6c-2.43,2.86-2.4,7.48-1.62,10.94s5.14,9.5,6.31,11.06l-2.28,2.47c-3.62,4-7.21,7.95-10.86,11.74-1.28,1.34-2.6,2.61-3.91,3.89.68-1,1.25-1.82,1.32-2,2.24-4.18,4.11-13.59.42-17.41a6.3,6.3,0,0,0-9.35.59c-2.42,2.87-2.39,7.49-1.61,10.95s4.71,8.91,6.1,10.78c-1.38,1.26-2.76,2.53-4.16,3.7-1,.77-1.85,1.58-2.87,2.31l-2.95,2.18c-1.92,1.33-3.9,2.7-5.81,3.95-1.33.87-2.6,1.68-3.89,2.5,1.3-1.32,3.78-3.95,4-4.19a24.48,24.48,0,0,0,4.24-11.58,7.55,7.55,0,0,0,.74-1.18,6.3,6.3,0,0,0-3.16-8.82c-5-1.87-12.87,3.57-15.82,7.29-.18.22-1.8,2.81-2.8,4.46.44-1.06.88-2.08,1.32-3.18.88-2.16,1.7-4.34,2.58-6.69.39-1.15.79-2.31,1.18-3.48s.71-2.42,1.08-3.64c.79-2.86,1.45-5.78,2.05-8.75,1.89.77,8.66,3.4,12.22,3.28s8-1.26,10.19-4.33a6.29,6.29,0,0,0-1.79-9.19c-4.63-2.61-13.26,1.58-16.74,4.8-.22.21-2.46,2.8-3.66,4.25.34-1.78.7-3.56,1-5.38.84-5.25,1.53-10.58,2.25-15.9.21-1.63.45-3.25.68-4.87.67.28,8.65,3.58,12.64,3.44,3.54-.12,8-1.26,10.18-4.33a6.29,6.29,0,0,0-1.78-9.19c-4.64-2.6-13.27,1.58-16.75,4.81-.26.24-3.48,4-4.25,5,.51-3.57,1-7.13,1.72-10.62A112,112,0,0,1,326,169.14c.31.13,8.62,3.62,12.71,3.48,3.54-.13,8-1.26,10.18-4.33a6.3,6.3,0,0,0-1.78-9.2c-4.64-2.6-13.26,1.58-16.75,4.81-.23.21-2.68,3.06-3.82,4.44l-.26-.15a80.67,80.67,0,0,1,6-13.12c1.3-2.32,2.66-4.47,4-6.53,1.48.81,8.29,4.42,12,4.71,3.54.26,8.11-.38,10.6-3.19a6.29,6.29,0,0,0-.77-9.33c-4.32-3.1-13.35.11-17.17,2.94-.2.15-2.14,1.94-3.53,3.27.63-.92,1.27-1.88,1.9-2.75,2.34-3.26,4.69-6.11,6.78-8.62,1.21-1.41,2.33-2.67,3.38-3.83,1.87,0,9.4.08,12.74-1.35s7-4.07,7.94-7.71a6.29,6.29,0,0,0-5-7.93c-5.26-.76-11.8,6.26-13.89,10.52-.18.37-2.33,6.46-2.24,6.46h.12c-1,1.1-2.15,2.29-3.33,3.62-2.15,2.46-4.57,5.27-7,8.49a112.39,112.39,0,0,0-7.33,10.79,82.25,82.25,0,0,0-6.39,13.11l-.06.17c.09-1.56.17-5.91.14-6.25-.44-4.73-4.07-13.6-9.26-14.75a6.29,6.29,0,0,0-7.46,5.65C308.06,156.29,310.63,160.13,313.19,162.58Z",
    style: {
      fill: "#9c9c9c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks-2--inject-691"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.67,338.61v-3.35c0-17.25,21.84-18,21.84-30.28,0-5.33-4.34-8.81-10.8-8.81-7.07,0-11.54,3.85-11.54,9.31v1.37c0,1.36-.74,2-2.11,2l-13.27-.5c-1.24,0-2.11-.62-2.11-1.48v-1.37c0-15,11.91-25.31,29.41-25.31,17.12,0,28.16,9.68,28.16,24.19,0,20.6-22.21,20.73-22.21,32v2.23a1.9,1.9,0,0,1-2.11,2.11H375.78A1.9,1.9,0,0,1,373.67,338.61Zm-1.12,20c0-5.46,4.84-9.93,10.67-9.93,5.59,0,10.55,4.47,10.55,9.93s-5,9.93-10.67,9.93S372.55,364.05,372.55,358.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.47,196.51V193.6c0-15,19-15.63,19-26.3,0-4.64-3.77-7.65-9.37-7.65-6.15,0-10,3.34-10,8.08v1.19c0,1.18-.64,1.72-1.83,1.72l-11.53-.43c-1.08,0-1.83-.54-1.83-1.29v-1.19c0-13,10.34-22,25.54-22,14.87,0,24.47,8.41,24.47,21,0,17.89-19.3,18-19.3,27.81v1.94a1.65,1.65,0,0,1-1.83,1.83H113.3A1.65,1.65,0,0,1,111.47,196.51Zm-1,17.35c0-4.74,4.2-8.62,9.26-8.62,4.85,0,9.17,3.88,9.17,8.62s-4.32,8.62-9.27,8.62A8.91,8.91,0,0,1,110.5,213.86Z",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.83,81.76V80.29c0-7.57,9.58-7.9,9.58-13.29,0-2.34-1.91-3.87-4.74-3.87-3.1,0-5.06,1.69-5.06,4.09v.6c0,.6-.33.87-.93.87l-5.82-.22c-.55,0-.93-.27-.93-.65v-.6c0-6.59,5.23-11.11,12.91-11.11,7.51,0,12.36,4.25,12.36,10.62,0,9-9.75,9.09-9.75,14v1a.83.83,0,0,1-.93.92h-5.77A.82.82,0,0,1,352.83,81.76Zm-.49,8.77A4.67,4.67,0,1,1,357,94.88,4.5,4.5,0,0,1,352.34,90.53Z",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,284v-1.85c0-9.54,12.08-9.95,12.08-16.75,0-2.95-2.4-4.87-6-4.87-3.91,0-6.38,2.13-6.38,5.15v.75c0,.76-.41,1.1-1.17,1.1l-7.34-.27c-.69,0-1.17-.35-1.17-.83v-.75c0-8.3,6.59-14,16.27-14,9.47,0,15.57,5.35,15.57,13.38,0,11.39-12.28,11.46-12.28,17.71V284a1.05,1.05,0,0,1-1.17,1.17H73.15A1.05,1.05,0,0,1,72,284Zm-.62,11.05a5.88,5.88,0,1,1,5.84,5.49A5.68,5.68,0,0,1,71.36,295.05Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,111.38v-1.27c0-6.56,8.31-6.85,8.31-11.52,0-2-1.65-3.35-4.11-3.35-2.69,0-4.39,1.46-4.39,3.54v.52c0,.52-.28.75-.8.75l-5-.19c-.47,0-.8-.23-.8-.56v-.52c0-5.71,4.53-9.63,11.18-9.63S179,92.83,179,98.35c0,7.84-8.45,7.89-8.45,12.18v.85a.72.72,0,0,1-.8.8h-5A.72.72,0,0,1,164,111.38Zm-.42,7.6a4,4,0,1,1,4,3.78A3.9,3.9,0,0,1,163.55,119Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,385.53v-1.27c0-6.56,8.31-6.84,8.31-11.52,0-2-1.65-3.35-4.11-3.35-2.69,0-4.39,1.46-4.39,3.54v.52c0,.52-.28.76-.8.76l-5-.19c-.47,0-.8-.24-.8-.57v-.52c0-5.71,4.53-9.63,11.18-9.63s10.72,3.68,10.72,9.21c0,7.83-8.45,7.88-8.45,12.17v.85a.73.73,0,0,1-.8.81h-5A.73.73,0,0,1,312,385.53Zm-.42,7.6a4,4,0,1,1,4,3.78A3.9,3.9,0,0,1,311.59,393.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-mark-1--inject-691"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.85,408.29c-.07-.21-.14-.42-.22-.63s-.14-.43-.22-.64-.14-.42-.22-.63-.14-.43-.22-.64-.14-.42-.22-.63-.14-.43-.22-.64l-.22-.63c-.07-.22-.15-.43-.22-.64l-.22-.63c-.07-.22-.15-.43-.22-.64l-.22-.63c-.07-.22-.15-.43-.22-.64L270,400c-.07-.22-.15-.43-.22-.64l-.23-.63c-.07-.22-.14-.43-.22-.64s-.14-.42-.22-.63-.14-.43-.22-.64-.14-.42-.22-.63c-3.26-9.92-13.34-17.2-24.43-17.2-10.75,0-20.1,6.26-24,15.08-.1.2-.19.41-.28.61l-.27.62c-.1.2-.19.4-.28.61s-.19.41-.28.61l-.27.61c-.1.21-.19.41-.28.62s-.19.4-.28.61-.19.4-.28.61l-.27.61c-.1.2-.19.41-.28.61s-.19.41-.28.61l-.27.62c-.1.2-.19.4-.28.61s-.19.41-.28.61l-.27.61c-.1.21-.19.41-.28.62s-.19.4-.28.61l-.27.61c-.1.2-.19.41-.28.61s-.19.41-.28.62A27.21,27.21,0,0,0,212.12,418c0,16.1,13.9,29.26,31.09,29.26,16.82,0,31.45-13.16,31.45-29.26a26.42,26.42,0,0,0-1.59-9C273,408.71,272.93,408.5,272.85,408.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.06,186.8c-51.57,0-86.68,30.35-86.68,74.61v4a3.84,3.84,0,0,0,1.9,3.26,4.91,4.91,0,0,0,.7.56,4.38,4.38,0,0,0,.71.56,4.38,4.38,0,0,0,.71.56,4,4,0,0,0,.71.56,4.3,4.3,0,0,0,.7.56,4.43,4.43,0,0,0,.71.57,5,5,0,0,0,.71.56,4.5,4.5,0,0,0,.71.56,4.41,4.41,0,0,0,.7.56,4.65,4.65,0,0,0,.77.6,5.63,5.63,0,0,0,.65.51,5,5,0,0,0,.71.56,4.91,4.91,0,0,0,.7.56,5,5,0,0,0,.71.56,4.5,4.5,0,0,0,.71.56,4.41,4.41,0,0,0,.7.56,4.5,4.5,0,0,0,.71.56,4.41,4.41,0,0,0,.7.56,5,5,0,0,0,.71.56,4.41,4.41,0,0,0,.7.56,5.89,5.89,0,0,0,4.2,1.46l32.16,1.2c3.31,0,5.11-1.5,5.11-4.81v-3.3c0-13.23,10.82-22.54,28-22.54,15.63,0,26.15,8.41,26.15,21.34a23.1,23.1,0,0,1-.42,4.39c-16.14,21.16-58.15,30.49-58.15,71.56v9.88c0,4,2.19,6.21,6.22,6.21H260.4c4,0,6.22-2.19,6.22-6.21v-6.59c0-33.28,65.47-33.65,65.47-94.36C332.09,215.32,299.53,186.8,249.06,186.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.41,359.07v-9.88c0-50.84,64.37-53,64.37-89.24,0-15.73-12.8-26-31.82-26-20.85,0-34,11.34-34,27.43v4c0,4-2.2,5.86-6.22,5.86l-39.14-1.47c-3.65,0-6.21-1.83-6.21-4.39v-4c0-44.26,35.11-74.61,86.68-74.61,50.47,0,83,28.52,83,71.32,0,60.71-65.47,61.08-65.47,94.36v6.59c0,4-2.2,6.21-6.22,6.21H221.63C217.6,365.28,215.41,363.09,215.41,359.07ZM212.12,418c0-16.09,14.26-29.26,31.45-29.26,16.46,0,31.09,13.17,31.09,29.26S260,447.21,243.21,447.21C226,447.21,212.12,434.05,212.12,418Z",
    style: {
      fill: "#BD95CF",
      stroke: "#BD95CF",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.61,
    cy: 467.79,
    rx: 54.61,
    ry: 12.21,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-691"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.87,190.85l-2.09,4.56s-12.14,1.31-12.14,2.22.13,7.18.79,7.44a2.15,2.15,0,0,0,1.56,0l17.88-4.57,1.7-8.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,199a43.45,43.45,0,0,1-7.15,4.76c-2.89,1.3-3,3.27-2.08,3.27s9.08-3.42,9.08-3.42,7.41-1.94,8.48-2.53,1.19-3.87,1.19-3.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.55 103.23 203.09 160.41 197.9 191.37 209.42 194.09 218.01 157.47 222.08 134.42 210.55 103.23",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.75 61.83 266.2 61.11 256.88 57.58 256.54 68.65 270.99 69.98 270.75 61.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.56,264.6A140.28,140.28,0,0,0,208.07,277c-3.85,5.88-2.49,12.2,2.26,13.79s10.84-2.72,12.43-6.11,1.13-5.19,3.61-8.58,4.52-6.78,3.62-11.3S220,261.44,217.56,264.6Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,285.53c-.32-.68-.69-1.4-1.13-2.17-3.63-6.39-10-5.88-14-4.69-2.63,5.37-1.13,10.71,3.18,12.15S220.22,288.74,222.3,285.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.17,283.36c-1.35,2-3.16,7.46-10.17,5.2a9.66,9.66,0,0,1-5-3.15,6.59,6.59,0,0,0,4.37,5.41c4.74,1.58,10.84-2.72,12.43-6.11s1.13-5.19,3.61-8.58,4.52-6.78,3.62-11.3c0,5.42-2,6.32-4.52,9.26S222.53,281.32,221.17,283.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.25,264.6A140.28,140.28,0,0,1,293.74,277c3.85,5.88,2.49,12.2-2.26,13.79s-10.84-2.72-12.43-6.11-1.13-5.19-3.61-8.58-4.52-6.78-3.62-11.3S281.77,261.44,284.25,264.6Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.52,285.53c.31-.68.68-1.4,1.12-2.17,3.63-6.39,10-5.88,14-4.69,2.63,5.37,1.13,10.71-3.18,12.15S281.59,288.74,279.52,285.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.64,283.36c1.35,2,3.16,7.46,10.17,5.2a9.66,9.66,0,0,0,5-3.15,6.59,6.59,0,0,1-4.37,5.41c-4.74,1.58-10.84-2.72-12.43-6.11s-1.13-5.19-3.61-8.58-4.52-6.78-3.62-11.3c0,5.42,2,6.32,4.52,9.26S279.28,281.32,280.64,283.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.85,186.63c0-4.07-7-8.59-7-8.59-10.55-10.73-29.59-9.31-36.62-8.35-7-1-26.06-2.38-36.61,8.35,0,0-7,4.52-7,8.59s8.82,77.52,8.82,77.52-.23,3.84,6.1,4.29,9-3.16,9-3.16l2.49-62.15s10.17-7.24,12-7.46c.66-.09,1.52-.23,2.48-.35v.12a13.3,13.3,0,0,1,5.43,0v-.12c1,.12,1.81.26,2.48.35,1.81.22,12,7.46,12,7.46l2.49,62.15s2.71,3.61,9,3.16,6.1-4.29,6.1-4.29S294.85,190.7,294.85,186.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,203.13s-1.36-14.92,5.2-20.57",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.06,203.13s.68-12.43-.68-16.95-3.62-6.33-3.62-6.33",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42,173.52s7.23,8.36,8.59,15.37",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.24,174s-4.07,4.52-4.52,7.91",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.07,86.06s-6.55-.91-8.81,1.35S229.31,98,229.31,98l4.07,71.87s9.27,3.62,17.18,3.62,16.95-2.94,19-4.52.23-78.65.23-78.65S253,85.38,248.07,86.06Z",
    style: {
      fill: "#BD95CF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.05,87.64a82.4,82.4,0,0,1,10.39-.91c4.52,0,9,.23,9,.23l11.3-10.85L268,70.91l1.81-10.39s16.72-1.13,25.08.45,21.47,5.65,22.15,5.65,1.58,2.49.9,4.29S296,96.23,289.65,102.33a155.92,155.92,0,0,0-11.75,12.88L275,165.61s7.46,4.07,8.82,5.42,2.94,6.78,2.94,6.78-13.79-5.65-17.41-6.1-5.87-.68-6.55-2-6.33-61.7-6.33-61.7l.23-19.21S256.66,87.64,260.05,87.64Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.61 118.6 261.4 120.18 262.53 124.7 268.64 126.28 274.51 123.57 273.61 118.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "280.61 91.48 277.9 115.21 284.91 95.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.78,76.11s5.65,1.13,14.24-2.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,77.69a51.07,51.07,0,0,0,11.07-.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.39,85.83l1.13,16.5a10.87,10.87,0,0,0,8.81,4.29c5.65-.22,6.33-4.29,6.33-4.29V88.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88,94.42,256.43,108l4.75-7.46s5.2,6.55,6.55,6.33-.9-2.94-1.35-5.42-4.3-11.31-4.75-13.79-4.75-2.94-5-1.81a11.54,11.54,0,0,0,0,2.94Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.29,106.62s.9,63.28-1.36,64-11.3.91-17,3.62-8.36,3.84-8.36,3.84,2.71-6.55,5.88-9.49a31.21,31.21,0,0,1,7-4.75l-5.87-30.28s-10.85-28.71-11.08-30.29,20.57-13.33,24.86-15.37,5.43-.22,5.43-.22Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.64,84.7s-5.42,17.18-5.88,19.44,0,2.26,1.59.67S237,99.39,237,99.39l4.29,7.23-.23-13.33V85.6S240.84,82.44,235.64,84.7Z",
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.02 121.77 238.35 121.77 238.13 127.19 232.25 129.22 224.79 127.19 225.02 121.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,62.33s3.16,13.78,3.84,16-3.61,11.08-5,13.11a6.58,6.58,0,0,1-5,3.16c-1.58,0-10.17-2.93-12.21-4.29s-4.06-2.94-4.06-2.94a5.43,5.43,0,0,1-5.88-.9c-2.71-2.49-6.33-5.43-5.43-7.46a5.31,5.31,0,0,1,5.2-3.16c2.49,0,1.59-.23,1.59-.23s-4.52-6.55-4.52-11.75,9.71-9,15.36-9a30.18,30.18,0,0,1,11.3,2.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "253.72 67.52 257.79 75.21 253.72 77.92 251.91 75.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.18,74.53s.22,1.81-2.49,4.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.43,70.35c0,1.06-.46,1.92-1,1.92s-1-.86-1-1.92.46-1.92,1-1.92S249.43,69.29,249.43,70.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.54,
    cy: 66.73,
    rx: 1.02,
    ry: 1.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.22,50.57S223,55.77,222.53,62.33s12.66,15.59,13.34,16.72,2.71-1.36,2.71-1.36a5.25,5.25,0,0,1-.91-4.29c.68-2.26,3.62-5,3.62-6.1s-3.39.9-3.39-2.49,8.36-5.42,13.33-5.2,9.27,8.59,12.89,4.52-1.59-5.19-1.59-5.19,7-.91,7-4.52-3.62-6.11-5.2-6.11-5.87,2.72-5.87-.22,4.29-4.3.22-9-9.26,0-9.26,1.81-1.36,5.19-2.26,5.19-3.62-4.06-6.78-1.8A8.38,8.38,0,0,0,237.22,50.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.1,
    y1: 67.98,
    x2: 250.33,
    y2: 65.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.46,62.1a3.11,3.11,0,0,1,.32-2.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,60c.51-1,1.66-2.29,4.2-3.34",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsBro);
export default __webpack_public_path__ + "static/media/questions-bro.f5fb04e2e39f522588cbfbf0b5c1a3d2.svg";
export { ForwardRef as ReactComponent };